import { WorkspacePlaceholder } from './WorkspacePlaceholder';
import { WorkspaceShell } from './WorkspaceShell';

export function ScenariosWorkspace(): JSX.Element {
  return (
    <WorkspaceShell title="Planificacion de Escenarios" status="shell">
      <WorkspacePlaceholder
        title="Planificacion de Escenarios"
        description="Construir y comparar hipotesis de intervencion, simulacion e impacto territorial u operativo."
        capabilities={[
          'Escenarios baseline, proposed y sensitivity',
          'Comparacion de alternativas',
          'Calculo de impactos territoriales',
          'Relacion con analisis y operacion',
          'Publicacion de escenarios aprobados',
        ]}
      />
    </WorkspaceShell>
  );
}
